import { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from "firebase.js"; // Ensure correct Firebase import
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

// Create AuthContext
const AuthContext = createContext();

// AuthProvider Component
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // For initial auth state loading

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        // Fetch user profile from Firestore
        const userRef = doc(db, "users", currentUser.uid);
        const userDoc = await getDoc(userRef);

        if (userDoc.exists()) {
          setUser({
            uid: currentUser.uid,
            email: currentUser.email,
            name: userDoc.data().name || "Utilisateur",
            role: userDoc.data().role || "user",
            master: userDoc.data().master || false,
            adminFor: userDoc.data().adminFor || "",
            photoURL: currentUser.photoURL || null,
          });
        }
      } else {
        setUser(null);
      }
      setLoading(false); // Auth state is now fully loaded
    });

    return () => unsubscribe(); // Cleanup listener on unmount
  }, []);

  // Logout function
  const logout = async () => {
    await signOut(auth);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use AuthContext
export const useAuth = () => {
  return useContext(AuthContext);
};
